<script>
  import { onMount } from "svelte"
  import InnerCard from "./innerCard.svelte"
  import bulkJson from "../../../Stores/jsonBulkData"
  import Pagination from "../../../../../../Shared/Table/Components/pagination.svelte"
  // import Pagination from "../../../Shared/pagination.svelte"

  /**
   * @type {Array<import("../../../Script/document".bulkDocument)>} - it consists of filtered json list. It displayed in list.
   */
  let sortData = []
  /**
   * @type {Number} maximum page count
   */
  let maxPage
  /**
   * @type {Number} active page of the pagination
   */
  let activePage = 1

  onMount(() => {
    // Reorganize the $bulkJson array by grouping documents based on their emailState and isEmailFailed properties

    // Filter and concatenate documents with email not sent that have failed
    const failedDocuments = $bulkJson.filter((a) => !a.emailState && a.isEmailFailed)

    // Filter and concatenate documents with no email sent that have not failed
    const waitingDocuments = $bulkJson.filter((a) => !a.emailState && !a.isEmailFailed)

    // Filter and concatenate documents with a successful email transmission
    const completedDocuments = $bulkJson.filter((a) => a.emailState)

    $bulkJson = [...failedDocuments, ...waitingDocuments, ...completedDocuments]

    maxPage = Math.ceil($bulkJson.length / 10)

    listEntries($bulkJson)
  })

  /**
   * @description function for what are list need to show
   * @function listEntries
   */
  const listEntries = ($bulkJson) => {
    // Calculate the maximum number of pages based on the length of jsonData and the number of entries per page
    maxPage = Math.ceil($bulkJson.length / 10)

    // Create an empty array to store the sorted data
    sortData = []

    // Iterate through $bulkJson starting from the index corresponding to the current page
    for (let i = 10 * (activePage - 1); i < $bulkJson.length; i++) {
      // Check if the sortData array has reached the desired number of entries per page
      if (sortData.length < 10) {
        // Add the current $bulkJson element to the sortData array
        sortData = [...sortData, $bulkJson[i]]
      }
    }
  }
</script>

<!-- <Pagination bind:sortData json={$bulkJson} /> -->

<div class="mt-6 flex w-full select-none flex-col items-center justify-between gap-3 text-sm sm:flex-row sm:gap-0 sm:text-base">
  <!-- How many entries shows in total entries -->
  <p class="font-medium text-gray-200">
    Showing {activePage * 10 - 10 + 1} to {activePage * 10 > $bulkJson.length ? $bulkJson.length : activePage * 10} of
    <span class="font-mono font-bold text-blue-500">{$bulkJson.length}</span>
    entries
  </p>

  {#if maxPage}
    <Pagination
      {maxPage}
      activePage={1}
      on:pageNo={(e) => {
        activePage = e.detail
        listEntries($bulkJson)
      }}
    />
  {/if}
</div>

<div class="mt-6 flex w-full select-none flex-col gap-3">
  {#each sortData as document}
    <InnerCard {document} />
  {:else}
    <h1>In processing ...</h1>
  {/each}
</div>
